// Tell the server about something that went wrong on this device, so it can
// be read from the logs (scripts/logs.sh "client event") instead of pieced
// together from a description. Fire and forget: reporting must never be the
// thing that breaks. The server only accepts a fixed list of event names and
// small values; never send a filename or anything the person typed.
export type ClientEvent = 'picker_open' | 'picker_change' | 'picker_cancel' | 'picker_empty' | 'picker_lost' | 'upload_failed' | 'preview_broken' | 'js_error'

export function report(event: ClientEvent, detail?: Record<string, string | number | boolean>) {
  try {
    void fetch('/api/client-events', {
      method: 'POST',
      keepalive: true, // survive the page going away
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ event, path: location.pathname, detail }),
    }).catch(() => {})
  } catch {
    /* nothing to do */
  }
}

let reported = 0
const onError = (message: string) => {
  if (reported++ < 5) report('js_error', { message: message.slice(0, 200) })
}
window.addEventListener('error', (e) => onError(e.message || 'error'))
window.addEventListener('unhandledrejection', (e) => onError(String((e.reason as Error)?.message ?? e.reason)))
